"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useSelector = exports.useDispatch = exports.default = void 0;

var _react = require("react");

var _reactRedux = require("react-redux");

var context = /*#__PURE__*/(0, _react.createContext)();
var useDispatch = (0, _reactRedux.createDispatchHook)(context);
exports.useDispatch = useDispatch;
var useSelector = (0, _reactRedux.createSelectorHook)(context);
exports.useSelector = useSelector;
context.displayName = 'WebChatReduxContext';
var _default = context;
exports.default = _default;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy9ob29rcy9pbnRlcm5hbC9XZWJDaGF0UmVkdXhDb250ZXh0LmpzIl0sIm5hbWVzIjpbImNvbnRleHQiLCJ1c2VEaXNwYXRjaCIsInVzZVNlbGVjdG9yIiwiZGlzcGxheU5hbWUiXSwibWFwcGluZ3MiOiI7Ozs7Ozs7QUFBQTs7QUFDQTs7QUFFQSxJQUFNQSxPQUFPLGdCQUFHLDJCQUFoQjtBQUVBLElBQU1DLFdBQVcsR0FBRyxvQ0FBbUJELE9BQW5CLENBQXBCOztBQUNBLElBQU1FLFdBQVcsR0FBRyxvQ0FBbUJGLE9BQW5CLENBQXBCOztBQUVBQSxPQUFPLENBQUNHLFdBQVIsR0FBc0IscUJBQXRCO2VBRWVILE8iLCJzb3VyY2VSb290IjoiY29tcG9uZW50Oi8vLyIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCB7IGNyZWF0ZUNvbnRleHQgfSBmcm9tICdyZWFjdCc7XG5pbXBvcnQgeyBjcmVhdGVEaXNwYXRjaEhvb2ssIGNyZWF0ZVNlbGVjdG9ySG9vayB9IGZyb20gJ3JlYWN0LXJlZHV4JztcblxuY29uc3QgY29udGV4dCA9IGNyZWF0ZUNvbnRleHQoKTtcblxuY29uc3QgdXNlRGlzcGF0Y2ggPSBjcmVhdGVEaXNwYXRjaEhvb2soY29udGV4dCk7XG5jb25zdCB1c2VTZWxlY3RvciA9IGNyZWF0ZVNlbGVjdG9ySG9vayhjb250ZXh0KTtcblxuY29udGV4dC5kaXNwbGF5TmFtZSA9ICdXZWJDaGF0UmVkdXhDb250ZXh0JztcblxuZXhwb3J0IGRlZmF1bHQgY29udGV4dDtcblxuZXhwb3J0IHsgdXNlRGlzcGF0Y2gsIHVzZVNlbGVjdG9yIH07XG4iXX0=